module.exports = __webpack_public_path__ + "assets/img/7.0c628407.png";